import { render, staticRenderFns } from "./StandardizedHosting.vue?vue&type=template&id=29b95ed6&scoped=true&"
import script from "./StandardizedHosting.vue?vue&type=script&lang=js&"
export * from "./StandardizedHosting.vue?vue&type=script&lang=js&"
import style0 from "./StandardizedHosting.vue?vue&type=style&index=0&id=29b95ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b95ed6",
  null
  
)

export default component.exports